/* eslint-disable eol-last */
import request from '@/utils/request'

export function orderquery(query) {
  return request({
    url: '/api/produce/backworkorder/query',
    method: 'get',
    params: query
  })
}
export function orderpush(data) { // 新建工单
  return request({
    url: '/api/produce/backworkorder/add',
    method: 'post',
    data
  })
}
export function workupdate(data) { // 修改工单
  return request({
    url: '/api/produce/backworkorder/workaddupdate',
    method: 'post',
    data
  })
}
export function deletework(data) { // 删除工单
  return request({
    url: '/api/produce/backworkorder/deletework',
    method: 'post',
    data
  })
}
// 加工单列表
export function workorderprocessingList(data) {
  return request({
    url: '/api/produce/workorderprocessing/pagelist',
    method: 'post',
    data
  })
}
// 结束工单
export function workorderprocessingComplete(data) {
  return request({
    url: '/api/produce/workorderprocessing/complete',
    method: 'post',
    data
  })
}

// 新建加工单
export function workorderprocessingAdd(data) { 
  return request({
    url: '/api/produce/workorderprocessing/add',
    method: 'post',
    data
  })
}
// 分解加工单
export function workorderprocessingResolve(data) { 
  return request({
    url: '/api/produce/workorderprocessing/resolve',
    method: 'post',
    data
  })
}
// 删除加工单
export function workorderprocessingDelete(data) { 
  return request({
    url: '/api/produce/workorderprocessing/delete',
    method: 'post',
    data
  })
}
// 生产子加工单
export function workorderprocessingsubtaskList(data) {
  return request({
    url: '/api/produce/workorderprocessingsubtask/pagelist',
    method: 'post',
    data
  })
}
// 生产子加工单编辑
export function workorderprocessingsubtaskUpdate(data) {
  return request({
    url: '/api/produce/workorderprocessingsubtask/update',
    method: 'post',
    data
  })
}

// 删除生产子加工单
export function workSubtaskDelete(data) { 
  return request({
    url: '/api/produce/workorderprocessingsubtask/delete',
    method: 'post',
    data
  })
}

export function workaddupdatecount(data) { // 人工确认数量
  return request({
    url: '/api/produce/backworkorder/newInstorage',
    method: 'post',
    data
  })
}
export function InstorageList(data) { // 入库明细
  return request({
    url: '/api/produce/backworkorder/InstorageList',
    method: 'post',
    data
  })
}
export function delInstorage(data) { // 入库明细删除
  return request({
    url: '/api/produce/backworkorder/delInstorage',
    method: 'post',
    data
  })
}
export function eidtInstorage(data) { // 入库明细修改
  return request({
    url: '/api/produce/backworkorder/eidtInstorage',
    method: 'post',
    data
  })
}

export function complete(data) { // 删除工单
  return request({
    url: '/api/produce/backworkorder/complete',
    method: 'post',
    data
  })
}
export function queryproduct(query) { // 下载工单
  return request({
    url: '/api/produce/backworkorder/queryproduct',
    method: 'get',
    params: query
  })
}
//质检报告
export function qualityreports(data) { // 获取质检报告
  return request({
    url: '/api/produce/backworkorder/qualityreports',
    method: 'post',
    data
  })
}
export function qualityreportsupdate(data) { // 编辑质检报告
  return request({
    url: '/api/produce/backworkorder/qualityfield',
    method: 'post',
    data
  })
}
export function uploadimg(data) { // 上传图片
  return request({
    url: '/api/produce/fileuploader/uploadimg',
    method: 'post',
    data
  })
}
export function downloadimg(query) {// 预览下载图片
  return request({
    url: '/api/openmt/productpicnoauthpic/download',
    method: 'get',
    params: query
  })
} 
// 工厂管理
export function factorylist(query) {
  return request({
    url: '/api/produce/factory/list',
    method: 'get',
    params: query
  })
}
export function listdistinct(query) {
  return request({
    url: '/api/produce/factory/listdistinct',
    method: 'get',
    params: query
  })
}
export function factoryadd(data) {
  return request({
    url: '/api/produce/factory/add',
    method: 'post',
    data
  })
}
export function factorydelete(data) {
  return request({
    url: '/api/produce/factory/delete',
    method: 'post',
    data
  })
}
export function factoryupdate(data) {
  return request({
    url: '/api/produce/factory/update',
    method: 'post',
    data
  })
}
// 车间管理
export function workshoplist(query) {
  return request({
    url: '/api/produce/workshop/list',
    method: 'get',
    params: query
  })
}
export function workshopadd(data) {
  return request({
    url: '/api/produce/workshop/add',
    method: 'post',
    data
  })
}
export function workshopdelete(data) {
  return request({
    url: '/api/produce/workshop/delete',
    method: 'post',
    data
  })
}
export function workshopupdate(data) {
  return request({
    url: '/api/produce/workshop/update',
    method: 'post',
    data
  })
}
// 产线管理
export function worklinelist(query) {
  return request({
    url: '/api/produce/workline/list',
    method: 'get',
    params: query
  })
}
export function worklineadd(data) {
  return request({
    url: '/api/produce/workline/add',
    method: 'post',
    data
  })
}
export function worklinedelete(data) {
  return request({
    url: '/api/produce/workline/delete',
    method: 'post',
    data
  })
}
export function worklineupdate(data) {
  return request({
    url: '/api/produce/workline/update',
    method: 'post',
    data
  })
}
// 班组管理
export function workgrouplist(data) {
  return request({
    url: '/api/produce/workgroup/list',
    method: 'post',
    data
  })
}
export function workgroupadd(data) {
  return request({
    url: '/api/produce/workgroup/add',
    method: 'post',
    data
  })
}
export function workgroupdelete(data) {
  return request({
    url: '/api/produce/workgroup/delete',
    method: 'post',
    data
  })
}
export function workgroupupdate(data) {
  return request({
    url: '/api/produce/workgroup/update',
    method: 'post',
    data
  })
}
// 包装关联查询
export function packquery(query) {
  return request({
    url: '/api/produce/packagerelation/query',
    method: 'get',
    params: query
  })
}
// 关联替换查询
export function replacequery(query) {
  return request({
    url: '/api/produce/coderelated/replacequery',
    method: 'get',
    params: query
  })
}
// 码解除关联查询
export function relievequery(query) {
  return request({
    url: '/api/produce/coderelated/relievequery',
    method: 'get',
    params: query
  })
}
// 箱码查询
export function querybox(query) {
  return request({
    url: '/api/produce/packagerelation/querybox',
    method: 'get',
    params: query
  })
}
// 任务管理列表
export function tasklist(query) {
  return request({
    url: '/api/produce/workordertask/list',
    method: 'get',
    params: query
  })
}
// 任务管理列表
export function taskstart(data) {
  return request({
    url: '/api/produce/workordertask/start',
    method: 'post',
    data
  })
}
// 任务管理列表
export function startagain(data) {
  return request({
    url: '/api/produce/workordertask/startagain',
    method: 'post',
    data
  })
}
// 日志列表
export function logindex(query) {
  return request({
    url: '/api/produce/outbilllog/logindex',
    method: 'get',
    params: query
  })
}
// 工单数据下载-盐业
export function downloadbackwork(query) {
  return request({
    url: '/api/produce/backworkorder/download',
    method: 'get',
    params: query
  })
}
// 迁移数据
export function updateqrcodeworkorder(data) {
  return request({
    url: 'api/produce/backworkorder/updateqrcodeworkorder',
    method: 'post',
    data
  })
}
// 出库数据下载-盐业
export function downloadoutbill(query) {
  return request({
    url: '/api/produce/outbillorder/download',
    method: 'get',
    params: query
  })
}
// 重码查询
export function recodelist(query) {
  return request({
    url: '/api/produce/recode/list',
    method: 'get',
    params: query
  })
}
// 工单扩展属性模块
// 列表
export function workordextendlist(query) {
  return request({
    url: '/api/produce/workorderseniorextend/pagelist',
    method: 'get',
    params: query
  })
}
// 详情
export function workordextenddetails(query) {
  return request({
    url: '/api/produce/workorderseniorextend/details',
    method: 'get',
    params: query
  })
}
// 新增
export function workordextendadd(data) {
  return request({
    url: '/api/produce/workorderseniorextend/add',
    method: 'post',
    data
  })
}
// 修改
export function workordextendedit(data) {
  return request({
    url: '/api/produce/workorderseniorextend/edit',
    method: 'post',
    data
  })
}
// 删除
export function workordextenddel(data) {
  return request({
    url: '/api/produce/workorderseniorextend/del',
    method: 'post',
    data
  })
}
// 工单扩展包装关系
// 列表
export function workorderpacklist(query) {
  return request({
    url: '/api/produce/workorderpack/list',
    method: 'get',
    params: query
  })
}
// 详情
export function workorderpackdetails(query) {
  return request({
    url: '/api/produce/workorderpack/details',
    method: 'get',
    params: query
  })
}
// 新增
export function workorderpackadd(data) {
  return request({
    url: '/api/produce/workorderpack/add',
    method: 'post',
    data
  })
}
// 修改
export function workorderpackedit(data) {
  return request({
    url: '/api/produce/workorderpack/edit',
    method: 'post',
    data
  })
}
// 删除
export function workorderpackdel(data) {
  return request({
    url: '/api/produce/workorderpack/del',
    method: 'post',
    data
  })
}
// 工单采集率
export function samplingrate(query) {
  return request({
    url: '/api/produce/backworkorder/samplingrate',
    method: 'get',
    params: query
  })
}
// 查询原料投料信息分页列表
export function MaterialsBatchLogPagelist(query) {
  return request({
    url: '/api/produce/mterialsbatchlog/pagelist',
    method: 'get',
    params: query
  })
}
export function MaterialsBatchLogordernolist(query) {// 生产工单查询
  return request({
    url: '/api/produce/mterialsbatchlog/ordernolist',
    method: 'get',
    params: query
  })
}
export function MaterialsBatchLogadd(data) {
  return request({
    url: '/api/produce/mterialsbatchlog/add',
    method: 'post',
    data
  })
}
export function MaterialsBatchLogupdate(data) {
  return request({
    url: '/api/produce/mterialsbatchlog/update',
    method: 'post',
    data
  })
}
export function MaterialsBatchLogdel(data) {
  return request({
    url: '/api/produce/mterialsbatchlog/del',
    method: 'post',
    data
  })
}
export function batchqualitystatus(data) {
  return request({
    url: '/api/produce/backworkorder/batchqualitystatus',
    method: 'post',
    data
  })
}
// 手工推送erp单据
export function pushproduce(query) {
  return request({
    url: '/api/out/xj/push/produce',
    method: 'get',
    params: query
  })
}

//生产导出记录列表
export function scExportList(query) { 
  return request({
    url: '/api/produce/backworkorder/exportList',
    method: 'get',
    params: query
  })
}
//生产导出请求
export function scExportRequest(query) { 
  return request({
    url: '/api/produce/backworkorder/exportRequest',
    method: 'get',
    params: query
  })
}

//出库导出记录列表
export function outExportList(query) { 
  return request({
    url: '/api/produce/outbillorder/exportList',
    method: 'get',
    params: query
  })
}
//生产导出请求
export function outExportRequest(query) { 
  return request({
    url: '/api/produce/outbillorder/exportRequest',
    method: 'get',
    params: query
  })
}
//导出已生成好的数据
export function exportDataDownload(query) { 
  return request({
    url: '/api/produce/exportdata/download',
    method: 'get',
    params: query
  })
}

// 码生码周期查询
export function qrcodelifecycleQuery(query) {
  return request({
    url: '/api/out/qrcodelifecycle/query',
    method: 'get',
    params: query
  })
}